<panel [width]="virkCompany || loading ? 700 : 500">

  <ng-container *requiredCredential="updateCompanyVatNumberCredential">
    @if (!virkCompany) {
      <form>
        <h1>{{ 'company.edit-cvr.title' | translate }}</h1>
        <section one-column>
          <custom-input (click)="resetSearchResults()"
            [inputType]="inputTypeEnum.Text"
            [label]="'company.edit-cvr.input-label' | translate"
            [placeholder]="'company.edit-cvr.input-placholder' | translate"
            [(value)]="searchVatNumber"
          [required]="true"></custom-input>
        </section>
        @if (!loading) {
          <list-view emptyLabel="">
            @if (searchResult && searchResult.length === 0) {
              <list-item alert>{{ 'company.edit-cvr.no-results' | translate }}</list-item>
            }
            @if (otherCompanyWithVatNumber) {
              <list-item alert>{{ 'company.edit-cvr.error.cvr-already-used-by' | translate: { 'companyName' : otherCompanyWithVatNumber.companyName} }}</list-item>
            }
          </list-view>
        }
        <section>
          <button #lookupVatNumberButton
            [active]="searchVatNumber !== ''"
            (click)="lookupVatNumber()"
            [ignoreValidation]="true"
          [label]="'company.edit-cvr.search' | translate"></button>
        </section>
      </form>
    }
  </ng-container>

  @if (loading) {
    <section>
      <skeletons [customSkeletons]="[['2em', '100%', 'col-6'], ['2em', '100%', 'col-6']]" class="row" />
      <div class="row">
        <div class="col-6"><skeletons [defaultSkeletons]="8" /></div>
        <div class="col-6"><skeletons [defaultSkeletons]="8" /></div>
      </div>
    </section>
  }

  @if (!loading && !credentialService.hasCredentials(updateCompanyVatNumberCredential) && otherCompanyWithVatNumber) {
    <list-view emptyLabel="">
      <list-item alert>{{ 'company.edit-cvr.error.cvr-already-used-by' | translate: { 'companyName' : otherCompanyWithVatNumber.name} }}</list-item>
    </list-view>
  }

  @if (!loading && virkCompany) {
    <section>
      <div>
        <h1>{{ 'company.edit-cvr.details-title-old' | translate }}</h1>
        <section>
          <icon type="building" />
          <text-group>
            {{ company.name }}<br />
            {{ company.address }}<br />
            {{ company.zipcode }} {{ company.city }}<br />
            {{ 'company.vat-number' | translate }} {{ company.vatNumber }}<br />
            {{ 'company.business-type' | translate }} {{ company.businessType }}<br />
            {{ 'company.business-status' | translate }} {{ company.businessStatus }}<br />
            {{ 'company.advertisement-protection' | translate }} {{ (company.advertisingProtection ?  'company.advertisement-protection-true' : 'company.advertisement-protection-false') | translate }}<br />
            {{ 'company.establishment-date' | translate }} {{ company.establishmentDate | customDate: 'shortDate' }}<br />
          </text-group>
        </section>
      </div>
      <div>
        <h1>{{ 'company.edit-cvr.details-title-new' | translate }}</h1>
        <section>
          <icon type="building" />
          <text-group>
            {{ virkCompany.name }}<br />
            {{ virkCompany.address }}<br />
            {{ virkCompany.zipcode }} {{ virkCompany.city }}<br />
            {{ 'company.vat-number' | translate }} {{ virkCompany.vatNumber }}<br />
            {{ 'company.business-type' | translate }} {{ virkCompany.businessType }}<br />
            {{ 'company.business-status' | translate }} {{ virkCompany.businessStatus }}<br />
            {{ 'company.advertisement-protection' | translate }} {{ (virkCompany.advertisingProtection ?  'company.advertisement-protection-true' : 'company.advertisement-protection-false') | translate }}<br />
            {{ 'company.establishment-date' | translate }} {{ virkCompany.establishmentDate | customDate: 'shortDate' }}<br />
          </text-group>
        </section>
      </div>
    </section>
    <section>
      <button #updateCompanyByVatNumberButton [ignoreValidation]="true" (click)="updateCompanyByVatNumber()" [label]="'company.edit-cvr.replace-details' | translate"></button>
    </section>
  }
</panel>
